<template>
  <div class="px-2">
    <v-row align="center">
      <v-col cols="auto" class="d-flex align-center">
        <dropdown
          :label="$t('order_status')"
          :items="statusItems"
          v-model="orderStatus"
          hide-details
        />
      </v-col>
      <v-col cols="auto" class="d-flex align-center" style="min-width: 220px">
        <autocomplete
          :label="$t('visible_columns')"
          :items="columnOptions"
          v-model="visibleColumns"
          multiple
          chips
          deletable-chips
          hide-details
        />
      </v-col>
      <v-col
        cols="auto"
        class="d-flex align-center"
        v-if="visibleColumns.includes('shifts')"
      >
        <shift-picker v-model="selectedShifts" multiple />
      </v-col>
    </v-row>

    <v-row justify="center" class="py-15" no-gutters v-if="loading">
      <v-col cols="auto">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
    <template v-else>
      <v-data-table
        :headers="headers"
        :items="customSearch(users, headers, search)"
        :loading="loading"
        class="striped-table ordera-box-shadow mt-4"
        hide-default-footer
        disable-pagination
        dense
      >
        <template v-slot:no-data>
          <v-container class="text-center py-12">
            <v-icon size="64" color="grey lighten-1" class="mb-4">
              mdi-account-off
            </v-icon>
            <div class="text-h6 grey--text text--darken-1 mb-2">
              {{ $t("no_employees_report_data") }}
            </div>
            <div class="text-body-2 grey--text">
              {{ $t("select_date_and_filters") }}
            </div>
          </v-container>
        </template>
        <template v-slot:item.num="{ index }">
          {{ index + 1 }}
        </template>
        <template v-slot:item.actions="{ item }">
          <circle-button
            @click="openDialogReportUser(item)"
            color="primary"
            icon="mdi-format-list-bulleted"
            :tooltip="$t('tooltip_order_details')"
          />
        </template>
        <template v-slot:body.append v-if="orderStatus !== 2">
          <tr class="font-weight-bold">
            <td :colspan="baseColspan"></td>
            <td>{{ $t("total") }}</td>
            <td
              class="text-center"
              v-if="visibleColumns.includes('shifts') && selectedShifts.includes(1)"
            >
              {{ getTotalForColumn("shift_one") }}
            </td>
            <td
              class="text-center"
              v-if="visibleColumns.includes('shifts') && selectedShifts.includes(2)"
            >
              {{ getTotalForColumn("shift_two") }}
            </td>
            <td
              class="text-center"
              v-if="visibleColumns.includes('shifts') && selectedShifts.includes(3)"
            >
              {{ getTotalForColumn("shift_three") }}
            </td>
            <td
              class="text-center"
              v-if="visibleColumns.includes('shifts') && selectedShifts.includes(4)"
            >
              {{ getTotalForColumn("shift_four") }}
            </td>
            <td class="text-center">{{ getTotalForColumn("order_count") }}</td>
            <td class="text-center">{{ getTotalForColumn("order_payed") }}</td>
            <td class="text-center">{{ getTotalForColumn("difference") }}</td>
            <td></td>
          </tr>
        </template>
      </v-data-table>
      <company-report-dialog-employee v-model="employeeDialog" :employee="selectedUser" />
    </template>
  </div>
</template>

<script>
import reportService from "@/services/report";
import CompanyReportDialogEmployee from "@/components/company/reports/companyTabs/dialogs/companyEmployeeOrdersDialog.vue";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";

export default {
  name: "CompanyReportTabMeals",
  mixins: [hasPrinting, hasExcel, hasReportPrinting],
  components: {
    CompanyReportDialogEmployee,
  },
  data() {
    return {
      report: null,
      loading: false,
      selectedUser: {},
      employeeDialog: false,
      orderStatus: 0, // Default: all users
      selectedShifts: [1, 2, 3, 4], // Po default sve četiri smene, kad su smjene uključene
      visibleColumns: ["id", "external_code"], // Smjene su podrazumevano isključene
    };
  },
  created() {
    this.fetchUserlist();
  },
  methods: {
    fetchUserlist() {
      this.loading = true;
      reportService
        .getCompanyMealKorisnici(this.selectedCompanies, {
          date: this.dates.from,
          date2: this.dates.to,
        })
        .then((response) => {
          this.report = response.data;
        })
        .catch((error) => {
          console.error("Error fetching meals:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialogReportUser(item, food) {
      this.selectedUser = item;
      this.employeeDialog = true;
    },
    getTotalForColumn(column) {
      return this.users.reduce((total, user) => total + (user[column] || 0), 0);
    },
    createTotalRow() {
      return {
        id: this.$t("total"),
        num: "",
        external_code: "",
        full_name: "",
        shift_one: this.getTotalForColumn("shift_one"),
        shift_two: this.getTotalForColumn("shift_two"),
        shift_three: this.getTotalForColumn("shift_three"),
        shift_four: this.getTotalForColumn("shift_four"),
        order_count: this.getTotalForColumn("order_count"),
        order_payed: this.getTotalForColumn("order_payed"),
        difference: this.getTotalForColumn("difference"),
        actions: "",
      };
    },
  },
  computed: {
    statusItems() {
      return [
        { text: this.$t("all"), value: 0 },
        { text: this.$t("users_ordered"), value: 1 },
        { text: this.$t("not_ordered"), value: 2 },
        { text: this.$t("taken"), value: 3 },
        { text: this.$t("users_ordered_not_taken"), value: 4 },
      ];
    },
    columnOptions() {
      return [
        { text: "ID", value: "id" },
        { text: this.$t("external_code"), value: "external_code" },
        { text: this.$t("shifts"), value: "shifts" },
      ];
    },
    baseColspan() {
      // r_b, plus id/external_code kad su prikazani; "full_name" kolona nosi labelu Ukupno
      let count = 1;
      if (this.visibleColumns.includes("id")) count += 1;
      if (this.visibleColumns.includes("external_code")) count += 1;
      return count;
    },
    filteredUsers() {
      if (!this.report || !Array.isArray(this.report.users)) {
        return [];
      }

      let filteredUsers = this.report.users;

      // Filter by order status
      if (this.orderStatus !== 0) {
        filteredUsers = filteredUsers.filter((user) => {
          const hasOrders = (user.order_count || 0) > 0;
          const hasTaken = (user.order_payed || 0) > 0;

          switch (this.orderStatus) {
            case 1: // Users who ordered
              return hasOrders;
            case 2: // Users who didn't order
              return !hasOrders;
            case 3: // Users who taken
              return hasOrders && hasTaken;
            case 4: // Users who ordered but didn't take
              return hasOrders && !hasTaken;
            default:
              return true;
          }
        });
      }

      return filteredUsers;
    },
    users() {
      return this.filteredUsers.map((user, index) => ({
        ...user,
        name: this.toLatin(user.name),
        lastname: this.toLatin(user.lastname),
        full_name: `${this.toLatin(user.name)} ${this.toLatin(user.lastname)}`,
        num: index + 1,
        // Naručeno/preuzeto/razlika su uvek pravi ukupni brojevi, bez obzira na izbor smjena.
        // Izbor smjena utiče samo na opcioni prikaz kolona po smjenama ispod.
        shift_one: this.selectedShifts.includes(1) ? user.shift_one || 0 : 0,
        shift_two: this.selectedShifts.includes(2) ? user.shift_two || 0 : 0,
        shift_three: this.selectedShifts.includes(3) ? user.shift_three || 0 : 0,
        shift_four: this.selectedShifts.includes(4) ? user.shift_four || 0 : 0,
        order_count: user.order_count || 0,
        order_payed: user.order_payed || 0,
        difference: (user.order_count || 0) - (user.order_payed || 0),
      }));
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies.map((company) => company.id);
    },
    dates() {
      return this.$store.state.report.filters.dates;
    },
    restaurantId() {
      return this.$store.state.company?.restaurant_id || this.$store.state.company;
    },
    headers() {
      const baseHeaders = [{ text: this.$t("r_b"), value: "num", print: false }];

      if (this.visibleColumns.includes("id")) {
        baseHeaders.push({ text: "ID", value: "id" });
      }
      if (this.visibleColumns.includes("external_code")) {
        baseHeaders.push({ text: this.$t("external_code"), value: "external_code" });
      }

      baseHeaders.push({ text: this.$t("full_name"), value: "full_name" });

      const shiftHeaders = [];

      // Kolone po smjenama se prikazuju samo ako je uključena opcija "Smjene"
      if (this.visibleColumns.includes("shifts")) {
        if (this.selectedShifts.includes(1)) {
          shiftHeaders.push({
            text: this.$t("shift_one"),
            value: "shift_one",
            align: "center",
          });
        }
        if (this.selectedShifts.includes(2)) {
          shiftHeaders.push({
            text: this.$t("shift_two"),
            value: "shift_two",
            align: "center",
          });
        }
        if (this.selectedShifts.includes(3)) {
          shiftHeaders.push({
            text: this.$t("shift_three"),
            value: "shift_three",
            align: "center",
          });
        }
        if (this.selectedShifts.includes(4)) {
          shiftHeaders.push({
            text: this.$t("shift_four"),
            value: "shift_four",
            align: "center",
          });
        }
      }

      const endHeaders = [
        { text: this.$t("ordered"), value: "order_count", align: "center" },
        { text: this.$t("taken"), value: "order_payed", align: "center" },
        { text: this.$t("difference"), value: "difference", align: "center" },
        {
          text: this.$t("actions"),
          value: "actions",
          sortable: false,
          print: false,
          align: "center",
        },
      ];

      return [...baseHeaders, ...shiftHeaders, ...endHeaders];
    },
    search() {
      return this.$store.state.report.filters.search;
    },
  },
  watch: {
    dates: {
      handler() {
        this.fetchUserlist();
      },
      deep: true,
    },
    selectedCompanies(newVal, oldVal) {
      this.fetchUserlist();
    },
    isPrinting(newVal, oldVal) {
      if (newVal) {
        const printHeaders = this.headers.filter((h) => h.print !== false);
        const baseItems = this.customSearch(this.users, printHeaders, this.search);
        const printItems =
          this.orderStatus !== 2 ? [...baseItems, this.createTotalRow()] : baseItems;

        this.printDocument({
          title: [this.$t("report"), this.$t("employees")].join(": "),
          tables: [
            {
              headers: printHeaders,
              items: printItems,
              showCaption: true,
            },
          ],
          hideDatetime: true,
          subtitle: this.subtitle,
        });
      }
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        const excelHeaders = this.headers.filter((h) => h.value !== "actions");
        const baseExcelItems = this.customSearch(this.users, excelHeaders, this.search);
        const excelItems =
          this.orderStatus !== 2
            ? [...baseExcelItems, this.createTotalRow()]
            : baseExcelItems;

        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("employees")].join(" ") + ".xlsx",
          sheets: [
            {
              name: this.$t("employees"),
              headers: excelHeaders,
              items: excelItems,
              title: [this.$t("report"), this.$t("employees")].join(" "),
              subtitle: this.subtitle,
            },
          ],
        });
      }
    },
  },
};
</script>
